// バックエンドの検証 (AllowedDomainPattern) と同じ許可ドメインの規則。
// example.com (完全一致) または *.example.com (サブドメインのワイルドカード) のみ許可する。
// (この規則はバックエンド Izanagi.Sandbox.Podman/Egress/AllowedDomainPattern.cs と同期すること)
export const ALLOWED_DOMAIN_PATTERN = /^(\*\.)?([A-Za-z0-9-]+\.)+[A-Za-z0-9-]+$/;

/** FQDN の全体長上限 (RFC 1035)。バックエンドと同じ値。 */
const MAX_DOMAIN_LENGTH = 253;

/**
 * 許可ドメインの構文エラーメッセージを返す。妥当なドメインならば null。
 * 空欄 (空白のみ含む) は「未入力」であってエラーではないため null を返す。
 * 前後の空白は保存時に除去される仕様に合わせ、無視して判定する。
 */
export function domainSyntaxError(domain: string): string | null {
	const trimmed = domain.trim();
	if (trimmed.length === 0) return null;
	if (trimmed.length > MAX_DOMAIN_LENGTH || !ALLOWED_DOMAIN_PATTERN.test(trimmed)) {
		return "ドメインの形式が不正です (example.com または *.example.com)";
	}
	return null;
}
